<div class="break"></div>
<div class="gender-item-wrapper" [class]="class" [ngClass]="{'gender-item-wrapper': index !=2, 'gender-item-special-wrapper': index ==2}">
  <app-text class="gender-item"  [class]="itemClass">{{itemName}}</app-text>
</div>
